// Central home for localStorage key names that both the page/util owning
// the cache AND clearLocalUserData.js (which needs to know all of them to
// wipe per-account data on logout) need to agree on. Keeping the string
// here — instead of duplicating it, or reaching into a page module just to
// grab a constant — avoids drift if one side renames its key, and doesn't
// risk pulling a whole page's code into whatever imports this for the name
// alone (which would matter if Upload/Search were ever code-split).
export const UPLOAD_DRAFT_KEY = "virsa_upload_draft";
export const RECENT_SEARCHES_KEY = "virsa_recent_searches";
export const RECENTLY_VIEWED_KEY = "virsa_recently_viewed";
export const PROFILE_CACHE_KEY = "virsa_profile_cache";
export const FEED_CACHE_KEY = "virsa_feed_cache";
